import React, { createContext, useState, useEffect } from "react";
import { useUser } from "./UserContext"; // Ensure this provides current user info
import { fetchCart, addToCartApi, removeFromCartApi, clearCartApi, setCartDiscountApi } from "./api/api";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const { user } = useUser(); // Get current user
    const [cart, setCart] = useState([]);
    const [discount, setDiscount] = useState(0);

    // persist discount (Global, browser-level)
    // useEffect(() => {
    //     localStorage.setItem("cart_discount", discount);
    // }, [discount]);

    // Load cart from backend whenever the user changes
    useEffect(() => {
        if (user) {
            const loadCart = async () => {
                try {
                    const cartData = await fetchCart(); // Fetch cart from backend
                    setDiscount(Number(cartData.discount) || 0);
                    // console.log('Cart loaded:', cartData);
                    if (cartData && Array.isArray(cartData.items)) {
                        // Transform items if necessary
                        const transformedItems = cartData.items.map(item => ({
                            id: item.id, // produces cart item id
                            product: item.product, // produces product id
                            name: item.name, // Ensure serializer includes 'name'
                            unit_name: item.unit_name, // Ensure serializer includes 'unit_name'
                            quantity: parseFloat(item.quantity) || 1,
                            price: parseFloat(item.price) || 0.00,
                            is_vat_applicable: item.is_vat_applicable,
                            isAlternativeUnit: !!item.unit_id,
                            unit_id: item.unit_id || null,
                            conversion_factor: parseFloat(item.conversion_factor) || 1.0,
                            unit_cost_price: parseFloat(item.unit_cost_price) || 0.00,
                        }));
                        setCart(transformedItems);
                    } else {
                        setCart([]);
                    }
                } catch (error) {
                    console.error('Failed to load cart:', error);
                    setCart([]);
                }
            };
            loadCart();
        } else {
            setCart([]); // Clear cart if no user is logged in
        }
    }, [user]);

    // Function to add product to cart via backend API
    const addToCart = async (product) => {
        try {
            const response = await addToCartApi(product); // Add to cart via API
            // console.log('Added to cart:', response);

            // Update local cart state with the new item
            setCart(prevCart => {
                // Check if item already exists in cart
                const existingIndex = prevCart.findIndex(item => item.id === response.id);

                console.log('server returned:', response);
                console.log('cart:', prevCart);

                if (existingIndex !== -1) {
                    // Update the existing item (e.g., quantity, price)
                    const updatedCart = [...prevCart];
                    updatedCart[existingIndex] = {
                        ...prevCart[existingIndex],
                        // quantity: response.quantity,
                        // price: response.price,
                        ...response,
                    };
                    console.log('updated cart:', updatedCart);
                    return updatedCart;
                }

                // Add the new item if it doesn't already exist
                return [...prevCart, response];
            });
        } catch (error) {
            console.error('Failed to add to cart:', error);
        }
    };


    // Function to remove item from cart via backend API
    const removeFromCart = async (item_id) => {
        try {
            await removeFromCartApi(item_id); // Remove item via API
            setCart(prevCart => prevCart.filter(item => item.id !== item_id));
        } catch (error) {
            console.error('Failed to remove from cart:', error);
        }
    };

    // Function to clear the cart via backend API
    const clearCart = async () => {
        try {
            await clearCartApi(); // Clear cart via API
            setCart([]);
            // Also clear any persisted cart data in localStorage or sessionStorage
            setDiscount(0);
            localStorage.removeItem('cart_discount');
        } catch (error) {
            console.error('Failed to clear cart:', error);
        }
    };

    // Function to update cart items (e.g., quantity)
    const updateCart = async (index, updatedItem) => {
        try {
            // Optionally, send an API request to update the item
            // For now, just update the local state
            const updatedCart = [...cart];
            updatedCart[index] = updatedItem;
            setCart(updatedCart);
            // If needed, send an API request to update the item
        } catch (error) {
            console.error('Failed to update cart:', error);
        }
    };

    // added
    const updateDiscount = async (value) => {
        const clean = Math.max(0, Number(value) || 0);
        setDiscount(clean);
        await setCartDiscountApi(clean);
    }
    // end of added

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, updateCart, discount, setDiscount: updateDiscount }}>
            {children}
        </CartContext.Provider>
    );
};
